import { render, staticRenderFns } from "./IconFireFlame.vue?vue&type=template&id=cf18abd4&scoped=true&"
import script from "./IconFireFlame.vue?vue&type=script&lang=js&"
export * from "./IconFireFlame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf18abd4",
  null
  
)

export default component.exports